import { useEffect, useState } from "react";
import Popup from "./Popup";
import API_URLS from "../Urls";
import EditSearch from "./EditSearch"
import Table1 from "./Table1";
import Dropdown2 from "./Dropdown2";
import DropdownSearch from "./DropdownSearch";
import Button from "./Button";
import { AuthProvider, useAuth } from "./AuthProvider";
import EditText from "./EditText";
import Checkbox from "./Checkbox";

const ViewProcess = ({ onClose, claim }) => {
  const [fetchedUpdates, setFetchedUpdates] = useState([])
  const [content, setContent] = useState('')
  const { user } = useAuth();
  const [control, setControl] = useState({})

  const [loading, setLoading] = useState(true)
  const [clientData, setClientData] = useState({})
  const [droneData, setDroneData] = useState({})
  const [technician, setTechnician] = useState('Técnico Asignado')
  const [lastUpdate, setLastUpdate] = useState('')
  const [newUpdate, setNewUpdate] = useState('')
  const [updateStatus, setUpdateStatus] = useState('⏳')
  const [processStages, setProcessStages] = useState([
    { tipo: 1, name: 'Proceso de diagnóstico', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 2, name: 'Inspección de software', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 3, name: 'Inspección técnica', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 4, name: 'Cotización lista', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 5, name: 'Pedido de piezas', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 6, name: 'Recepcion de piezas', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 7, name: 'Reparacion', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 8, name: 'Listo para entrega', estado: 'No iniciado', notas: '', visible: "No" },
    { tipo: 9, name: 'Termina proceso', estado: 'No iniciado', notas: '', visible: "No" }
  ])
  const generateFolio = (clientId, fechaNota, sucursal, id) => {
    let fechaFormateada = "000000";

    const id_formatted = String(Number(id)).padStart(3, '0'); // "007"
    let id_sucursal = "NR"; // DATO X
    if (fechaNota) {
      const parts = fechaNota.split('-');
      if (parts.length === 3) {
        const [year, day, month] = parts;
        fechaFormateada = `${month}${day}${year}`;
      }
    }
    if (sucursal == 'Aguascalientes') {
      id_sucursal = 'CA'
    } else {
      id_sucursal = 'CZ'
    }
    return `${id_sucursal}${clientId}${fechaFormateada}${id_formatted}`;
  };

  // Función para generar el folio de servicio


  const fetchData = (url, onSuccesful) => {
    return fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }

    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
        return response.json();
      })
      .then(data => {
        if (typeof onSuccesful === 'function') onSuccesful(data);

      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  }

  const postData = (url, dataToSend, onSuccesful) => {
    console.log("Posting to URL:", url);
    console.log("Data to send:", dataToSend);

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(dataToSend)
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok ' + response.statusText);
        return response.json();
      })
      .then(data => {
        if (typeof onSuccesful === 'function') { onSuccesful(data); alert('Cambios guardados correctamente'); };
        console.log(data);
      })
      .catch(error => console.error('There was a problem with the fetch operation:', error));
  };

  const updateStageStatus = (index, field, value) => {
    setProcessStages(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };
  const fetchStages = async () => {
    setLoading(true);

    const fetchProcess = fetchData(
      API_URLS.PROCESS + '?nota_id=' + claim.id,
      (data) => {
        if (data.length > 0) {
          const onlyVisible = Array.isArray(data) ? data.filter((d) => d?.visible === 'Si') : [];
          setProcessStages((prevStages) =>
            prevStages.map((stage) => {
              const match = onlyVisible.find((element) => element.tipo === stage.tipo);
              return match ? { ...stage, ...match } : stage;
            })
          );
          const latest = [...data]
            .filter(d => d && d.fecha)
            .sort((a, b) => String(a.fecha).localeCompare(String(b.fecha)))
            .pop();
          if (latest) {
            setLastUpdate(latest.fecha);
            setTechnician(latest.hecha_por || 'Técnico Asignado');
          }
        }
      }
    );

    await fetchProcess; // not Promise(...)
    setLoading(false);
  };
  useEffect(() => {
    // Cargar datos del cliente
    if (claim && claim.cliente) {
      fetchData(API_URLS.CLIENTS + "?id=" + claim.cliente, (data => {
        if (data && data.length > 0) {
          setClientData(data[0]);
        }
      }))
    }

    // Cargar datos del dron (simulado por ahora)
    fetchData(API_URLS.CLAIMOBJECT + '?id=' + claim.id, (baseData) => {
      const fetchPromises = baseData.map(item =>
        new Promise((resolve) => {
          let url = "";
          switch (item.tipo) {
            case 'Dron Enterprise':
            case 'Dron Comercial':
              url = API_URLS.DRONES;
              break;
            case 'Parte':
              url = API_URLS.PARTS;
              break;
            case 'Accesorio':
            case 'Accesorios':
              url = API_URLS.ACCESORIES;
              break;
            default:
              console.warn(`Unknown tipo: ${item.tipo}, skipping`);
              return resolve(null); // skip this item
          }

          fetchData(url + '?id=' + item.objectid, (detailData) => {
            if (!detailData || detailData.length === 0) {
              console.warn(`No data found for objectid=${item.objectid}`);
              return resolve(null);
            }

            const { tipo: _, ...itemWithoutTipo } = item;
            resolve({
              ...detailData[0],
              ...itemWithoutTipo,
              objecttype: item.tipo // preserve original tipo separately
            });
          });
        })
      );

      Promise.all(fetchPromises)
        .then(enrichedObjects => {
          const validObjects = enrichedObjects.filter(item => item !== null);
          setDroneData(
            validObjects.filter(
              item => item.objecttype === "Dron Enterprise" || item.objecttype === "Dron Comercial"
            )[0] || {}
          );

          setControl(
            validObjects.filter(item => item.tipo === "Control")[0] || {}
          );
        })
        .catch(error => {
          console.error('Error enriching object data:', error);
        });
    });
    fetchStages()

  }, [claim])
  return (
    <Popup title='Servicio de Reparación' onClose={() => { onClose() }}>
      {/* Encabezado del servicio */}
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', margin: '5px 0' }}>
          {generateFolio(claim.cliente, claim.fecha, claim.sucursal, claim.id)}
        </h1>
        <h2 style={{ fontSize: '20px', margin: '5px 0', color: '#555' }}>Servicio de Reparación</h2>
        <div style={{ fontSize: '14px', color: '#777' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
            className="invisible-horizontal-container"
          >
            <div className="invisible-horizontal-container">
              Técnico:
              <EditText
                style={{ width: '50%' }}
                defaultText={technician || 'N/A'}
                onChange={(text) => setTechnician(text)}
              />
            </div>
          </div>
          Última actualización: <strong>{lastUpdate || 'N/A'}</strong>
        </div>
      </div>

      {/* Información del cliente */}
      <div className="invisible-horizontal-container" style={{ marginBottom: '15px' }}>
        <div>Cliente: <strong>{`${clientData?.nombre || ''} ${clientData?.apellidos || ''}`}</strong></div>
      </div>

      {/* Información del equipo */}
      <div className="header1">Información del Equipo</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px', marginBottom: '20px' }}>
        <div>
          <strong>Modelo:</strong><br />
          {droneData.linea || 'N/A'} {droneData.serie || 'N/A'} {droneData.modelo || 'N/A'}
        </div>
        <div>
          <strong>SN de aeronave:</strong><br />
          {droneData.no_serie || 'N/A'}
        </div>
        <div>
          <strong>SN de control:</strong><br />
          {control.modelo || 'N/A'}
        </div>
      </div>





      {/* Etapas del proceso */}
      <div className="header1">Etapas del Proceso</div>
      {loading ? (
        <div>
          Cargando...
        </div>) : (
        <div style={{ marginBottom: '20px' }}>
          {processStages.map((stage, index) => (
            <div key={index} style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '5px' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>{stage.name}</div>
              <div className="invisible-horizontal-container" style={{ marginBottom: '5px' }}>
                <div>Estado:</div>
                <Dropdown2
                  options={['No iniciado', 'En proceso', 'Terminado']}
                  returnSelectedOption={(option) => updateStageStatus(index, 'estado', option)}
                  value={stage.estado}
                />
              </div>
              <div style={{ marginBottom: '5px' }}>
                <EditText
                  style={{ width: '100%', height: '100px' }}
                  defaultText={stage.notas}
                  onChange={(text) => updateStageStatus(index, 'notas', text)}
                  placeholder="Notas adicionales..."
                />
              </div>
              <div className="invisible-horizontal-container">
                <button style={{ padding: '5px 10px', background: '#eee', border: '1px solid #ddd', borderRadius: '4px', marginRight: '10px' }}>
                  Subir imagen
                </button>
                Visible para el cliente?:
                <Checkbox
                  text="Visible para cliente"
                  checked={stage.visible == 'Si'}
                  onChange={(checked) => updateStageStatus(index, 'visible', checked ? "Si" : "No")}
                />
              </div>
            </div>
          ))}
        </div>
      )}


      {/* Botones de acción */}
      <div style={{ display: 'flex', justifyContent: 'right', marginTop: '20px' }}>
        <Button
          text="Guardar cambios"
          onClick={async () => {
            try {
              const postNewPromises = processStages.map(item =>

                postData(API_URLS.PROCESS, { ...item, hecha_por: technician, nota_id: claim.id }));
              await Promise.all([
                ...postNewPromises
              ]);
              fetchStages()

            } catch (error) {
              console.error("❌ Error during saving operations:", error);
            }


          }}
          color="#7AACE3"
        />

      </div>
    </Popup>
  )
};
export default ViewProcess;
